/* eslint-disable no-unused-vars */
import React from "react";
import { useContext } from "react";
import { Navigate } from "react-router-dom";

import LogoHeader from "../common/LogoHeader";

import Login from "../Login";
import useUserStore from "../../stores/useUserStores";

const AuthLogin = () => {
  const { islogin, isAdmin } = useUserStore();
  return (
    <>
      {!islogin && !isAdmin ? (
        <>
          <LogoHeader />
          <Login />
        </>
      ) : (
        <Navigate replace to="/dashboard" />
      )}
    </>
  );
};

export default AuthLogin;
